import Header from './components/Header';
import Hero from './components/Hero';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <FeaturesSection />
        <CommentsSection />
        <AboutSection />
        <CarouselSection />
        <FaqSection />
        <UpdatesSection />
        <AppSection />
        <RankingSection />
        <TopicsSection />
        <MediaSection />
        <ContactSection />
        <IndexSection />
        <CardsSection />
      </main>
      <Footer />
    </div>
  );
}